<template>
  <mtd-header ref="headerRef" class="mc-header" :style="styleObj">
    <div v-if="showTag" class="env-tag-container">
      <span class="mc-env-tag">{{ activeEnv }}</span>
    </div>
    <div class="mc-header-left-container">
      <slot name="left"></slot>
    </div>
    <div class="mc-header-right-container">
      <env-select :active-env="activeEnv" />
      <slot name="right"></slot>
    </div>
  </mtd-header>
</template>

<script>
import { Header as MtdHeader } from "@ss/mtd-vue";
import EnvSelect from "./components/EnvSelect.vue";
import { EnvNames } from "./interface";
import { getRegionPacks } from '@/utils';
import { RegionInitializer } from '@osgfe/web-region-store';

const getActiveEnv = () => {
  let NODE_ENV = process.env.NODE_ENV;
  return NODE_ENV || EnvNames.Production;
};

const shouldShowTag = (activeEnv) => {
  return [EnvNames.Test, EnvNames.Staging].includes(activeEnv);
};

const getStyleObj = (activeEnv, backgroundColor) => {
  const colorIndex =
    activeEnv === EnvNames.Development ? EnvNames.Test : activeEnv;
  return {
    "--background-color": backgroundColor[colorIndex],
  };
};

export default {
  name: "MCHeader",
  components: {
    MtdHeader,
    EnvSelect,
  },
  inject: ['$$event'],
  props: {
    systemType: {
      required: true,
      type: String,
    },
    backgroundColor: {
      type: Object,
      default() {
        return {
          test: "white",
          staging: "#FFFFFF",
          production: "rgb(255,255,255)",
        };
      },
    },
  },
  provide() {
    return {
      systemType: this.systemType,
    };
  },
  data() {
    return {
      activeEnv: getActiveEnv(),
    };
  },
  computed: {
    showTag() {
      return shouldShowTag(this.activeEnv);
    },
    styleObj() {
      return getStyleObj(this.activeEnv, this.backgroundColor);
    },
  },
  mounted() {
    this.initRegionStore();
  },

  methods: {
    async initRegionStore() {
      try {
        const fetchRegionPacks = async () => getRegionPacks();
        await RegionInitializer.initRegionPacks(fetchRegionPacks, {
          syncLocalStorage: true, // 跨 tab 持久化
          reloadOnChange: false, // 不在初始化时自动 reload，由业务方控制
        });
        // 通知其他组件RegionStore已就绪
        if (this.$$event) {
          this.$$event.$emit('regionStoreReady');
        }
      } catch (error) {
        // 静默处理错误，避免影响用户体验
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.env-tag-container {
  position: absolute;
  width: 100%;
  height: 25px;
  text-align: left;
  top: 0;
  left: 0;
}
</style>
